export default "__VITE_ASSET__37f86ee9__"